export default __webpack_public_path__ + "static/kcdotcom-e9829efce53da4498d20a7ce8a401051.jpeg";